<template>
  <v-form
		id="newProjectForm"
		class="pa-5" 
		ref="form"
		v-model="valid"
		lazy-validation
  >
	<v-text-field
		v-model="clientName"
		:rules="nameRules"
		label="Client Project Name"
		required
    ></v-text-field>	
    <v-text-field
		v-model="internalName"
		label="Internal Project Name"
    ></v-text-field>
    <v-text-field
		v-model="participantName"
		label="Respondent Project Name"
    ></v-text-field>  
    <v-textarea
		v-model="description"
		label="Project Description"
    ></v-textarea>
    <v-combobox
	v-model="quotas"
	v-on:change="removeSpaces('quotas')"
	:items="[ ]"
	label="Project Quotas"
	multiple
	chips
	></v-combobox>

    <v-btn
		color="error"
		class="mr-4"
		@click="reset"
    >
		Reset Form
    </v-btn>

    <v-btn
		:disabled="!valid"
		color="success"
		class="mr-4"
		@click="createProject"
    >
		Create Project
    </v-btn>
  </v-form>
</template>

<script>
import Vuex from 'vuex'
export default {
  name: 'NewProjectForm',
  props: {
	prefill: {type: Object }
  },
  data: () => (
	{
		dates: {}, 
		users: {},
		valid: true,
		clientName: '',
		participantName: '',
		request: false,
		quotas: [],
		internalName: null,
		description: '',
		nameRules: [
			v => !!v || 'Name is required',
		],
    }),
	watch: {
		clientName: function(newValue, oldValue){
			if( !this.internalName || this.internalName == oldValue ){ this.internalName = newValue; }
		}
	},
	computed: {
		...Vuex.mapState({
			userId: state => state.auth.user.uid
		})
	},
	methods: {
		removeSpaces(key){
			for( var i in this[key] ){
				this[key][i] = this[key][i].split(" ").join("-");
			}
		},
		createProject () {
			if( this.$refs.form.validate() ){
				const self = this;
				let users = this.users;
				users[this.userId] = "admin";
				let newProject = {
					publishStatus: "live",
					internalName: this.internalName,
					clientName: this.clientName,
					quotas: this.quotas,
					request: this.request,
					participantName: this.participantName,
					description: this.description,
					users: users, 
				};
				newProject.dates = this.dates;
				self.$store.dispatch( "addDoc", {
					collection: "projects",
					data: newProject
				} ).then( function( ref ){
					// self.$store.dispatch("bindAnything", {id: ref.id, collection: "projects", then: "SET_ANYTHING", reference: "projects"} )
					self.$refs.form.reset();
					self.$emit("created", ref.id, "project" )

				} );
			}
		},
		reset () {
			this.$refs.form.reset()
		},
		resetValidation () {
			this.$refs.form.resetValidation()
		},
    },
	created: function(){
		for( var key in this.prefill ){
			this[key] = this.prefill[key]
		}
	}
};
</script>
